import React, { type PropsWithChildren } from 'react';
import { Box } from '@chakra-ui/react';
import { useTranslate } from 'ts/common/hooks';
import BookingMarquee from 'client_react/booking/components/BookingMarquee';
import type { IBookingSession, IBookingSessionType } from 'client_react/booking/types';
import ClientPageHeading from 'client_react/common/components/ClientPageHeading';
import ClientPageLayout from 'client_react/common/components/ClientPageLayout';

interface Props {
    bookingSession?: Nullable<IBookingSession>;
    bookingSessionType?: Nullable<IBookingSessionType>;
}

const PageContainer = ({
    bookingSession,
    bookingSessionType,
    children
}: PropsWithChildren<Props>) => {
    const t = useTranslate('booking');

    const brandName = bookingSession?.brandName ?? bookingSessionType?.brandName ?? '';
    const images = bookingSession?.images ?? bookingSessionType?.images;

    const getBanner = () => {
        if (!images || images.length === 0) {
            return (
                <ClientPageHeading>
                    {!bookingSession || bookingSession.isIncomplete
                        ? bookingSessionType?.name ?? bookingSession?.bookingSessionTypeName
                        : t('confirmationPage.title')}
                </ClientPageHeading>
            );
        }

        return (
            <Box height="100%" maxWidth="1440px" overflow="hidden" width="100%">
                {images.length === 1 ? (
                    <Box
                        backgroundImage={`url(${images[0].url})`}
                        backgroundPosition="center"
                        backgroundSize="cover"
                        height="100%"
                        width="100%"
                    />
                ) : (
                    <BookingMarquee images={images} />
                )}
            </Box>
        );
    };

    return (
        <ClientPageLayout banner={getBanner()} headingText={brandName}>
            {children}
        </ClientPageLayout>
    );
};

export default PageContainer;
